function initializeWishlist() {
  // Get the wishlist from local storage
  var wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
  
  var message = document.getElementById('wishlistAlertMessage').dataset.message;
  var removed = document.getElementById('wishlistAlertMessage').dataset.removed;
  var alert = document.getElementById('wishlistAlertMessage').dataset.alert;
  var max = document.getElementById('wishlistAlertMessage').dataset.max;

  document.querySelectorAll('.wishlist-icon').forEach(function(icon) {
    
    var productHandle = icon.getAttribute('data-product-handle');
    
    if (wishlist.includes(productHandle)) {
        icon.classList.add('in-wishlist');
    }

    icon.addEventListener('click', function() {
      var index = wishlist.indexOf(productHandle);
      if (index > -1) {
        wishlist.splice(index, 1);
        icon.classList.remove('in-wishlist');
        if (removed) {
          showNotification(removed, 1);
        }
      } else  if (index == -1 && wishlist.length < max) {
        
        wishlist.push(productHandle);
        icon.classList.add('in-wishlist');  
        
        if (message) {
          showNotification(message, 1);
        }
      } else {
        if (alert) {
          showNotification(alert);
        }
      }
      
      localStorage.setItem('wishlist', JSON.stringify(wishlist));
      updateWishlistCounter();
    });
  });
   
  document.querySelectorAll('.wishlist-button').forEach(function(button) {
    var productHandle = button.getAttribute('data-product-handle');
    var wishlistIcon = button.querySelector('.wishlist-icon-main');
    var wishlistText = button.querySelector('.wishlist-text');
    var wishlistAddedText = button.querySelector('.wishlist-added-text');
  
    if (wishlist.includes(productHandle)) {
      wishlistIcon.classList.add('product-in-wishlist');
      wishlistText.classList.add('cgc-hide');
      wishlistAddedText.classList.remove('cgc-hide');
    }
  
    button.addEventListener('click', function() {
      
      var index = wishlist.indexOf(productHandle);
  
      if (index == -1 && wishlist.length < max) {
        wishlist.push(productHandle);
        wishlistIcon.classList.add('product-in-wishlist');  
        wishlistText.classList.add('cgc-hide');
        wishlistAddedText.classList.remove('cgc-hide');
        
        if (message) {
          showNotification(message, 1);
        }
      } else if (index > -1) {
      
        wishlist.splice(index, 1);
        wishlistIcon.classList.remove('product-in-wishlist'); 
        wishlistText.classList.remove('cgc-hide');
        wishlistAddedText.classList.add('cgc-hide');
        
        if (removed) {
          showNotification(removed, 1);
        }
      } else {
        if (alert) {
          showNotification(alert);
        }
      }
      
      localStorage.setItem('wishlist', JSON.stringify(wishlist)); updateWishlistCounter();
    });
  });
  
  updateWishlistCounter();
  renderWishlistItems(); 
};


function showNotification(message, durationInSeconds = 3) {
  var notification = document.createElement('div');
  notification.id = 'cgc_wishlist-notification';
  notification.className = 'cgc_wishlist-notification-container';
  
  var messageElement = document.createElement('p');
  messageElement.id = 'notification-message';
  messageElement.textContent = message;
  
  notification.appendChild(messageElement);

  document.body.appendChild(notification);
  
  notification.classList.remove('cgc-hide');
  
  setTimeout(function() {
    notification.classList.add('cgc-hide');
    document.body.removeChild(notification);
  }, durationInSeconds * 1000); 
}

function updateWishlistCounter() {
  var wishlist = getWishlist();
  var counterElements = document.querySelectorAll('.wishlist-counter');
  var counterElementWrappers = document.querySelectorAll('.wishlist-counter-wrapper');

  // Update each counter element wrapper
  counterElementWrappers.forEach(wrapper => {
    if (wishlist.length == 0) {
      wrapper.style.display = 'none';
    } else {
      wrapper.style.display = 'flex';
    }
  });

  // Update each counter element
  counterElements.forEach(counter => {
    if (wishlist.length > 0) {
      counter.style.display = 'inline';
      counter.textContent = wishlist.length;
    } else {
      counter.style.display = 'none';
    }
  });
}

function getWishlist() {
  var wishlist = localStorage.getItem('wishlist');
  return wishlist ? JSON.parse(wishlist) : [];
}

function setWishlist(wishlist) {
  localStorage.setItem('wishlist', JSON.stringify(wishlist));
}

function removeFromWishlist(productHandle) {
  
  var wishlist = getWishlist();
  var index = wishlist.indexOf(productHandle);
  if (index > -1) {
    wishlist.splice(index, 1);
    setWishlist(wishlist);
    updateWishlistCounter(); 
    renderWishlistItems(); 
  }
}

function removeFromWishlist(productHandle) {
  
  var wishlist = getWishlist();
  var index = wishlist.indexOf(productHandle);
  if (index > -1) {
    wishlist.splice(index, 1);
    setWishlist(wishlist);
    updateWishlistCounter(); 
    renderWishlistItems();
  }
}

async function renderWishlistItems() {
  
  var wishlistItemsContainer = document.querySelector('.wishlist-items');
  if (!wishlistItemsContainer) return;
  
  var wishlist = getWishlist().reverse();
  wishlistItemsContainer.innerHTML = '';
  
  const fetchProductDetails = (productHandle) => {
    
    return fetch(`/products/${productHandle}.js`)
      .then(response => response.json())
      .then(product => {
      return { productHandle, product };
    })
      
    .catch(error => {
      console.error('Error fetching product:', error);
      return null; 
    });
  };
  
  // Map wishlist items to an array of promises
  const fetchPromises = wishlist.map(productHandle => fetchProductDetails(productHandle));
  
  // Wait for all fetch operations to complete
  const productsWithHandles = await Promise.all(fetchPromises);
  
  // Iterate over the products array to maintain order
  productsWithHandles.forEach(({ productHandle, product }, index) => {
    
    if (!product) return; // Skip if the product wasn't fetched successfully
    
    var productElement = document.createElement('li');
    productElement.className = 'grid__item product-item-' + index;
    
    // Create a new div with class 'card-wrapper'
    var cardWrapper = document.createElement('div');
    cardWrapper.className = 'card-wrapper';
    
    // Create a new div with class 'card'
    var cardDiv = document.createElement('div');
    cardDiv.className = 'card';
    
    // Create a div to wrap the image
    var imageWrapper = document.createElement('div');
    //imageWrapper.className = 'media media--transparent media--hover-effect';
    imageWrapper.className = 'wishlist-media';
    
    // Product Image
    var imageUrl = product.images[0].replace(/(\.\w{3,4})(\?.*)?$/, '_600x600$1');
    var img = document.createElement('img');
    img.src = imageUrl;
    img.alt = product.title;
    img.classList.add('wishlist-image');

    img.style.objectPosition = focalPoint;
    
    var contentWrapper = document.createElement('div');
    //imageWrapper.className = 'media media--transparent media--hover-effect';
    contentWrapper.className = 'wishlist-content';
    
    // Create a link element
    var link = document.createElement('a');
    link.href = `/products/${product.handle}`; // Link to the product page
    link.appendChild(img); // Add the image to the link
    link.classList.add('wishlist-image-wrapper');
    
    // Append the link to the imageWrapper div
    imageWrapper.appendChild(link);
    cardDiv.appendChild(imageWrapper);

    //contentWrapper.appendChild(link);
    cardDiv.appendChild(contentWrapper);

    // Product Title
    var title = document.createElement('h4');
    title.className = 'h3';
    var link = document.createElement('a');
    link.href = `/products/${product.handle}`;
    link.textContent = product.title;
    link.className = 'full-unstyled-link';
    title.appendChild(link);
   
    contentWrapper.appendChild(title);
     
    // Product Price
    var price = document.createElement('div');
    price.className = 'wishlist-price';
    
    var priceValue = product.variants[0].price / 100; // Convert to standard format
    var compareAtPrice = product.variants[0].compare_at_price ? product.variants[0].compare_at_price / 100 : null;
        
    var formattedPrice = `${currencySymbol}${priceValue.toFixed(2)} ${currencyCode}`;
    var formattedCompareAtPrice = compareAtPrice ? `${currencySymbol}${compareAtPrice.toFixed(2)} ${currencyCode}` : '';

    var priceHtml = compareAtPrice && compareAtPrice > priceValue 
      ? `<s class="price-item price-item--regular">${formattedCompareAtPrice}</s> <span>${formattedPrice}</span>` 
      : `<span>${formattedPrice}</span>`;
    price.innerHTML = priceHtml;         
    
    contentWrapper.appendChild(price);
    
    cardWrapper.appendChild(cardDiv);
    
    productElement.appendChild(cardWrapper);
    
    wishlistItemsContainer.appendChild(productElement);
    
    var removeDiv = document.createElement('div');
    removeDiv.className = 'remove-wishlist-item';
    
    removeDiv.addEventListener('click', function() {
      removeFromWishlist(productHandle);
    });
    
    var svgNS = "http://www.w3.org/2000/svg";
    var svg = document.createElementNS(svgNS, "svg");
    svg.setAttributeNS(null, "aria-hidden", "true");
    svg.setAttributeNS(null, "focusable", "false");
    svg.setAttributeNS(null, "class", "icon icon-close");
    svg.setAttributeNS(null, "fill", "none");
    svg.setAttributeNS(null, "viewBox", "0 0 18 17");
    
    var path = document.createElementNS(svgNS, "path");
    path.setAttributeNS(null, "d", "M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z");
    path.setAttributeNS(null, "fill", "currentColor");
    
    svg.appendChild(path);
    
    var spanWrapper = document.createElement('span');
    spanWrapper.className = 'remove-wishlist-icon';          
    spanWrapper.appendChild(svg);
    
    removeDiv.appendChild(spanWrapper);
    
    productElement.appendChild(removeDiv);
    
    wishlistItemsContainer.appendChild(productElement);

  });
}

document.addEventListener("DOMContentLoaded", initializeWishlist);

// Reinitialize on Shopify's theme editor events
document.addEventListener('shopify:section:load', initializeWishlist);
document.addEventListener('shopify:section:unload', initializeWishlist);
document.addEventListener('shopify:block:select', initializeWishlist);
document.addEventListener('shopify:block:deselect', initializeWishlist);